/* eslint-disable indent */
/* eslint-disable no-undef */
export const displayToast = async (message, type, floating = false) => {
  const errorElem = document?.createElement('div');

  if (errorElem) {
    if (type === 'toast') {
      errorElem.className =
        'fixed bottom-24 rounded-lg text-center text-sm bg-white py-2 px-3 text-gray-800 font-semibold left-1/2 transform -translate-x-1/2 shadow-5xl';
    } else {
      errorElem.className = `${
        floating
          ? 'fixed whitespace-nowrap bottom-8 p-3 flex items-center gap-3 left-1/2 transform -translate-x-1/2 text-base text-blue-800'
          : 'w-full fixed bottom-0 inset-x-0 text-center text-base py-5 text-white'
      } ${
        type === 'error'
          ? 'bg-red-500'
          : type === 'success'
          ? 'bg-green-500'
          : type === 'warning'
          ? 'bg-yellow-500'
          : 'bg-blue-100'
      }`;
    }
    errorElem.style.zIndex = '1111';
    errorElem.innerHTML = message;
  }

  document?.getElementsByTagName('body')[0].appendChild(errorElem);

  await new Promise((resolve) => {
    setTimeout(resolve, 3000);
  });

  errorElem?.remove();
};

export default displayToast;
